import request from '@/utils/request'
import PizZipUtils from "pizzip/utils";
import Store from '@/store/store'
import {getUserInfos} from "@/utils/userInfos";
import {MessageBox} from "element-ui";

const getList = function(){

};

// 导出word
export const loadFile = (url, callback) => {
    PizZipUtils.getBinaryContent(url, callback);
}

// 图片base64转buffer
export const base64Parser = (dataURL) => {
    const base64Regex =
        /^data:image\/(png|jpg|svg|svg\+xml);base64,/;
    if (
        typeof dataURL !== "string" ||
        !base64Regex.test(dataURL)
    ) {
        return false;
    }
    const stringBase64 = dataURL.replace(base64Regex, "");

    // For nodejs
    if (typeof Buffer !== "undefined" && Buffer.from) {
        return Buffer.from(stringBase64, "base64");
    }

    // For browsers :
    const binaryString = window.atob(stringBase64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        const ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes.buffer;
}

// 图片url转base64
export const getBase64Image = (url) => {
    return new Promise((resolve, reject) => {

        var image = new Image()
        image.crossOrigin = '*' // 解决跨域问题
        image.src = url
        image.onload = function () {
            let canvas = document.createElement('canvas')
            canvas.width = image.width
            canvas.height = image.height
            let context = canvas.getContext('2d')
            // image.width、image.height调用时传入具体像素值，控制大小 ,不传则默认图像大小
            context.drawImage(image, 0, 0, image.width, image.height)
            let dataURL = canvas.toDataURL() // 得到图片的base64编码数据
            // console.log(dataURL)
            resolve(dataURL)
        }

        image.onerror = (error) => reject(error)
    }).catch(() => console.log('promise catch err')); //捕获异常)
}

// 文件类型输出
export function fileType(fileName) {
    // 后缀获取
    let suffix = '';
    // 获取类型结果
    let result = '';
    if (!fileName) return false;
    try {
        // 截取文件后缀
        suffix = fileName.substr(fileName.lastIndexOf('.') + 1, fileName.length)
        // 文件后缀转小写，方便匹配
        suffix = suffix.toLowerCase()
    } catch (err) {
        suffix = '';
    }
    // fileName无后缀返回 false
    if (!suffix) {
        result = false;
        return result;
    }

    let fileTypeList = [
        // 图片类型
        {'typeName': 'image', 'types': ['png', 'jpg', 'jpeg', 'bmp', 'gif']},
        // 文本类型
        {'typeName': 'txt', 'types': ['txt']},
        // excel类型
        {'typeName': 'excel', 'types': ['xls', 'xlsx']},
        {'typeName': 'word', 'types': ['doc', 'docx']},
        {'typeName': 'pdf', 'types': ['pdf']},
        {'typeName': 'ppt', 'types': ['ppt']},
        // 视频类型
        {'typeName': 'video', 'types': ['mp4', 'm2v', 'mkv']},
        // 音频
        {'typeName': 'radio', 'types': ['mp3', 'wav', 'wmv']}
    ]
    // let fileTypeList = ['image', 'txt', 'excel', 'word', 'pdf', 'video', 'radio']
    for (let i = 0; i < fileTypeList.length; i++) {
        const fileTypeItem = fileTypeList[i]
        const typeName = fileTypeItem.typeName
        const types = fileTypeItem.types

        result = types.some(function (item) {
            return item === suffix;
        });
        if (result) {
            return typeName
        }
    }
    return 'other'
}

// 图片url转base64
export function authUrlCheck(nowUrl, urlArr) {
    for (let i = 0; i < urlArr.length; i++) {
        if (nowUrl == urlArr[i]) {
            return true;
        }
    }
    dialogAuth();
    return false;
}

export function dialogAuth(){

    let userInfo = getUserInfos()
    let msg = '';
    if (userInfo.group_name) {
        msg = `暂无操作权限，如需更多权限请联系管理员\r\n(${userInfo.group_name}：${userInfo.group_mobile})！`
    } else {
        msg = `暂无操作权限，如需更多权限请联系管理员！`
    }

    MessageBox.confirm( msg, '权限不足', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true
    }).then(() => {

    }).catch(() => {

    });

}

export function userNameCheck(e) {
    var reg = /^[\u4e00-\u9fa5]{2,5}$/g;
    if (!reg.test(e)) {
        return false;
    }
    return true;
};

export default {
    getList
};

export function isMobile() {
    let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
};
